import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import "./CdDetails.scss"

import messages from "../../assets/i18n";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard"
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import CdHours from "../../components/CdHours/CdHours";
import CdCalendarExceptions from "../../components/CdCalendarExceptions/CdCalendarExceptions";
import CdCalendarExceptionsModal from "../../components/CdCalendarExceptionsModal/CdCalendarExceptionsModal";
import CdGates from "../../components/CdGates/CdGates";
import CdGateModal from "../../components/CdGateModal/CdGateModal";
import txWeekDays from '../../helpers/txWeekDays';
import { convertHourToDate } from '../../helpers/convertHour'
import ErrorMessageList from "../../components/ErrorMessageList";
import { ToastMessage, HeaderActions, FooterActions } from "../../components";
import getMessageError from '../../utils/getMessageError';

function CdDetails(props) {
	
	const dispatch = useDispatch();
	const lang = useSelector(state => state.language.name);
	const cdId = useSelector(state => state.cdDetails.cdSelect);
	const cdDetails = useSelector(state => state.cdDetails.cdDetails);
	const cdGates = useSelector(state => state.cdGates.cdGates);
	const cdGateModal = useSelector(state => state.cdGates.cdGateModal);
	const nameGate = useSelector(state => state.cdGates.cdGateModal.nome);
	const exceptions = useSelector(state => state.cdExceptions.cdExceptions);
	const exceptionsUpdate = useSelector(state => state.cdExceptions.cdExceptionsUpdate);
	const cdGateError = useSelector(state => state.cdGates.cdGateError);
	const cdGateSuccess = useSelector(state => state.cdGates.cdGateSuccess);
	const cdHourError = useSelector(state => state.cdDetails.cdHourError);
	const cdHourSuccess = useSelector(state => state.cdDetails.cdHourSuccess);
	const cdExceptionsError = useSelector(state => state.cdExceptions.cdExceptionsError);
	const cdExceptionsSuccess = useSelector(state => state.cdExceptions.cdExceptionsSuccess);
	const [modalShowCalendar, setModalShowCalendar] = useState(false);
	const [modalShowGate, setModalShowGate] = useState(false);
	const [msgError, setMsgError] = useState('');
	const [toastMessage, setToastMessage] = useState('');
	const [toastClass, setToastClass] = useState('toast-error');
	const [resetHours] = useState(false);
	const [show, setShow] = useState(false);

	const putCdDetails = (cdId, cdHours) => {
		dispatch({
			type: "PUT_CD_DETAILS",
			id: cdId, 
			hours: cdHours
		});
	}

	const cleanModal = () => {
		if (cdDetails) {
			let newGateHour = [];

			cdDetails.horarioCd.forEach(elem => {
				newGateHour.push(
					{
						id: null,
						idDiaSemana: elem.idDiaSemana,
						hrInicial: elem.hrInicial,
						hrFim: elem.hrFim,
						intervalo: 1,
						capacidade:0,
						carga: 1
					}
				)
			});

			dispatch({
				type: "SET_CD_GATE_MODAL",
				payload: {
					idCd: cdId,
					nome: '',
					capacidadeDinamica: false,
					horarios: newGateHour
				}
			});
		}
	};

	const handleClickSave = (cdId, cdHours)=> () => {
		const errors = errorHour(cdHours)
		if (errors.length > 0) {
			const txError = messages[lang].ErrorSalveCdHors;
			let msg = errors.reduce( (prev, current) => (prev + ' ' + messages[lang][txWeekDays(current.idDiaSemana)] + ',' ), txError );
			setMsgError('');
			setShow(true);
			setToastMessage(msg.substr(0, msg.length-1));
			setToastClass('toast-error');
		} else {
			setMsgError('');
			putCdDetails(cdId, cdHours);
		}
	}

	const errorHour = cdHours => (
		cdHours.reduce((prev, current) => (convertHourToDate(current.hrFim) >= convertHourToDate(current.hrInicial) ? prev : [...prev, current] ), [] )
	)

	useEffect(() => {
		dispatch({
			type: "GET_CD_DETAILS",
			id: cdId
		});

		dispatch({
			type: "GET_CD_GATES",
			id: cdId
		});
		// eslint-disable-next-line
	}, []);


	useEffect(() => {
		dispatch({
			type: "GET_CD_EXCEPTIONS",
			id: cdId
		});
		// eslint-disable-next-line
	},[exceptionsUpdate])

	useEffect(() => {
		if(cdGateError.error === true){
			
			let messageCode = getMessageError(cdGateError.data.message);
			setShow(true);
			setToastMessage( messages[lang].messagesCode[messageCode]);
			setToastClass('toast-error');
			dispatch({ type: "SET_CD_GATE_ERROR", payload:{ error: false }});
		}

		if(cdGateSuccess.success === true){
			let messageCode;
			if( cdGateSuccess.type === 'save' ){
				messageCode = 'gate002';
			} else if( cdGateSuccess.type === 'delete' ){
				messageCode = 'gate003';
			} else {
				messageCode = 'gate001';
			}
			setShow(true);
			setToastMessage( messages[lang].messagesCode[messageCode]);
			setToastClass('toast-success');
			dispatch({ type: "SET_CD_GATE_SUCCESS", payload:{ success: false }});
		}

		// eslint-disable-next-line
	},[cdGateError, cdGateSuccess]);

	useEffect(() => {
		if(cdHourError.error === true){ 
			let messageCode = getMessageError( cdHourError.data.message);
			setShow(true);
			setToastMessage( messages[lang].messagesCode[messageCode]);
			setToastClass('toast-error');
			dispatch({ type: "CD_HOUR_ERROR", payload:{ error: false }});
		}

		if(cdHourSuccess.success === true){			
			let messageCode = 'cdHour001';
			setShow(true);
			setToastMessage( messages[lang].messagesCode[messageCode]);
			setToastClass('toast-success');
			dispatch({ type: "CD_HOUR_SUCCESS", payload:{ success: false }});
		}
		// eslint-disable-next-line
	},[cdHourError, cdHourSuccess]);

	useEffect(() => {
		if(cdExceptionsError.error === true){ 
			let messageCode = getMessageError( cdExceptionsError.data.message);
			setShow(true);
			setToastMessage( messages[lang].messagesCode[messageCode]);
			setToastClass('toast-error');
			dispatch({ type: "SET_EXCEPTIONS_ERROR", payload:{ error: false }});
		}

		if(cdExceptionsSuccess.success === true){
			let messageCode = 'cdException001';
			if( cdExceptionsSuccess.type === 'delete' ){
				messageCode = 'cdException002';
			}
			setShow(true);
			setToastMessage( messages[lang].messagesCode[messageCode]);
			setToastClass('toast-success');
			dispatch({ type: "SET_EXCEPTIONS_SUCCESS", payload:{ success: false }});
		}
		// eslint-disable-next-line
	},[cdExceptionsError, cdExceptionsSuccess]);

	const pageBack = () => {
		dispatch({ type: "CD_DETAILS_CLEAN_ALL" });
		dispatch({ type: "CD_EXCEPTIONS_CLEAN_ALL" });
		dispatch({ type: "CD_CLEAN_GATES" });

		props.history.push('/cd-list');
	}

	const ButtonSave = () => (
		<ButtonStandard
			id="save_hours_button"
			text={messages[lang].save}
			textClass="text-3"
			className="btn btn-primary px-4 py-2 btn-light"
			onClick={handleClickSave(cdId, cdDetails.horarioCd)}
		/>
	)

	const ButtonGroupLeft = () => (
		<>
			<ButtonStandard
				id="load_remove_orders_button"
				text={messages[lang].includeException}
				textClass="text-3"
				className="btn btn-primary btn-standard px-3 py-2 btn-outline-light"
				onClick={() => setModalShowCalendar(true)}
			/>
			<ButtonStandard
				id="load_remove_orders_button"
				text={messages[lang].includeGate}
				textClass="text-3"
				className="btn btn-primary btn-standard px-3 py-2 btn-outline-light"
				onClick={() => { cleanModal(); (setModalShowGate(true)) }}
			/>
		</>
	)

	if (cdDetails === null) {
		return (
			<Container>
				<Row className="justify-content-center mt-5">
					<LoadingSpinner />
				</Row>
			</Container>
		)
	} else {
		return (
			<div className="cd-details-page">
				<ToastMessage show={show} setShow={setShow} message={toastMessage} toastClass={toastClass} ></ToastMessage>
				<HeaderActions pageBack={pageBack} titlePage={`${messages[lang].distributionCenter} - ${cdDetails.nome}`} />
				{
					msgError && (
						<ErrorMessageList errors={[msgError]} />
					)
				}
				<Container className="my-3">
					<Row className="extra-rounded-top bg-color-primary py-2 mb-1">
						<Col>
							<span className="text-4 font-weight-bolder">{messages[lang]["OpeningHours"]}</span>
						</Col>
					</Row>
				</Container>

				<Container className="px-0 mb-5 pb-5">
					<Row>
						<Col>
							<CdHours hours={cdDetails.horarioCd} resetHours={resetHours} />
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							{exceptions === null ?
								<Row className="justify-content-center mt-5">
									<LoadingSpinner />
								</Row>
							: exceptions === 404 ?
								<Row className="justify-content-center mt-5">
									<Col>
										<h3>{messages[lang]['NotFoundExceptions']}</h3>
									</Col>
								</Row>
							:
							<CdCalendarExceptions exceptions={exceptions} />
							}
						</Col>
						<Col xs={6}>
							{cdGates === null ?
								<Row className="justify-content-center mt-5">
									<LoadingSpinner />
								</Row>
							: cdGates.length <= 0 ?
								<Row className="justify-content-center mt-5">
									<Col>
										<h3>{messages[lang]['NotFoundGates']}</h3>
									</Col>
								</Row>
							:
								<CdGates type={"cd"} gates={cdGates} />
							}
						</Col>

					</Row>
				</Container>

				<FooterActions ButtonGroupLeft={ButtonGroupLeft} ButtonGroupRight={ButtonSave} />

				<CdCalendarExceptionsModal
						show={modalShowCalendar}
						onHide={() => setModalShowCalendar(false)}
					/>

				<CdGateModal
					show={modalShowGate}
					onHide={() => { cleanModal(); (setModalShowGate(false)) }}
					gate={cdGateModal}
					name={nameGate}
					title={messages[lang].registerGate}
					type={"create"}
				/>
			</div>
		)

	}
}

export default withRouter(CdDetails);